import {Moon, Sun} from '@phosphor-icons/react';
import {messages} from '@smartmixin/i18n';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {IconButton} from '../../components/ui';
import {setTheme} from '../../store/prefs';
import {useIsDarkTheme} from '../../theme/useIsDarkTheme';

/**
 * Dark theme on/off: a toggle named "Dark" whose pressed state says whether
 * it is on (was labelled "account of current user", a copy-paste of the
 * account menu's label). Flips the EFFECTIVE theme, so a user following a
 * dark OS switches to light. The full System / Light / Dark choice arrives
 * with the settings redesign.
 */
export const ThemeToggleButton = () => {
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const isDark = useIsDarkTheme();
  return (
    <IconButton
      aria-label={formatMessage(messages.settings.dark)}
      aria-pressed={isDark}
      onClick={() => dispatch(setTheme(isDark ? 'light' : 'dark'))}>
      {isDark ? <Sun /> : <Moon />}
    </IconButton>
  );
};
